//
//  SDKExporterCustomBlockVariant.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class ExporterCustomBlockVariant {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, blockKey) {
        this.blockKey = blockKey;
        this.variantKey = model.key;
        this.name = model.name;
        // TODO:fix-sdk-eslint
        // eslint-disable-next-line no-prototype-builtins
        this.isDefault = model.hasOwnProperty("isDefault") ? model.isDefault : false;
    }
}
